import './App.css';
import {ChakraProvider} from "@chakra-ui/react";
import Navi from "./components/Navi";
import React from "react";
import Footer from "./components/Footer";
import {Outlet} from "react-router-dom";

function App() {
    return (
        <ChakraProvider>
            <div className="App" style={{display: "flex", flexDirection: "column", justifyContent: "space-between", height: '100%'}}>
                <Navi />
                <main>
                    <Outlet />
                </main>
                <Footer />
            </div>
        </ChakraProvider>
    );
}

export default App;
